export default "__VITE_ASSET__3342d010__"